module.exports = __webpack_public_path__ + "media/src/assets/Images/BackgroundLogo-b2aead05816434b846606ad956932d82.png";